import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function DifferentiationSection() {
  const notIncluded = ['Frases memorizadas', 'Manipulación emocional', 'Actuar como alguien que no sos', 'Técnicas de presión', 'Promesas mágicas'];
  const included = ['Estructura clara', 'Orden emocional', 'Dirección con integridad', 'Psicología aplicada', 'Resultados sostenibles'];
  return <section className="py-32 bg-primary" data-id="element-20">
      <div className="max-w-6xl mx-auto px-6" data-id="element-21">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white mb-20 text-center" data-id="element-22">
          Esto NO es seducción barata.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24" data-id="element-23">
          {/* What it's NOT */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-24">
            {notIncluded.map((item, index) => <div key={index} className="flex items-center text-gray-400" data-id="element-25">
                <X className="text-red-900/60 mr-4 flex-shrink-0" size={24} data-id="element-26" />
                <span className="text-lg decoration-gray-700 decoration-1 line-through opacity-60" data-id="element-27">
                  {item}
                </span>
              </div>)}
          </motion.div>

          {/* What it IS */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-6 bg-tertiary/30 p-8 rounded-2xl border border-gold/10" data-id="element-28">
            {included.map((item, index) => <div key={index} className="flex items-center text-white" data-id="element-29">
                <Check className="text-gold mr-4 flex-shrink-0" size={24} data-id="element-30" />
                <span className="text-lg font-medium" data-id="element-31">{item}</span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}